import React from 'react'
import { ShiftManagementContext, type ShiftManagementContextValue } from './ShiftManagementContext'

export interface ShiftManagementContextProps {
  shiftManagementContext: ShiftManagementContextValue
}

type OriginalProps<P> = Omit<P, keyof ShiftManagementContextProps>

export function withShiftManagementContext<P extends ShiftManagementContextProps>(
  WrappedComponent: React.ComponentType<P>
): React.FC<OriginalProps<P>> {
  return function WrapperComponent(props: OriginalProps<P>) {
    return (
      <ShiftManagementContext.Consumer>
        {state => (
          // cast temporarily
          // Workaround for https://github.com/microsoft/TypeScript/issues/28884
          <WrappedComponent {...(props as P)} shiftManagementContext={state} />
        )}
      </ShiftManagementContext.Consumer>
    )
  }
}
